import { BaseEntity } from ".";
import { IGet_characters_character_id_fittings_200_ok } from "../service/esiclient";
import { getCachedCharacterEntity } from "./CharacterEntityCache";
import { getCachedTypeEntity } from "./TypeEntityCache";

export class CharacterFittingEntity extends BaseEntity {
  constructor(id: number, props: any, character_id: any) {
    super(id, props);
    this._dataTypeName = "Character Fitting";
    this._character_id = character_id;
  }

  async toJson(): Promise<Excel.EntityCellValue> {
    const props: Partial<IGet_characters_character_id_fittings_200_ok> = this.props;
    var entity = await super.toJson();
    // Properties
    if (entity.properties) {
      delete entity.properties["id"];
      const characterEntity = await getCachedCharacterEntity(this._character_id);
      if (characterEntity !== null) {
        entity.properties["owner"] = await characterEntity.toJson();
      }

      let item_array: Excel.CellValue[][] = [];
      if (props.items && props.items.length) {
        for (const i of props.items) {
          const typeEntity = await getCachedTypeEntity(i.type_id);
          if (typeEntity != null) {
            item_array.push([
              {
                type: Excel.CellValueType.entity,
                text: `${typeEntity.props["name"]}`,
                properties: {
                  type: await typeEntity.toJson(),
                  quantity: {
                    type: Excel.CellValueType.formattedNumber,
                    basicValue: i.quantity,
                    numberFormat: "##0",
                  },
                  flag: {
                    type: Excel.CellValueType.string,
                    basicValue: i.flag,
                  },
                },
              },
            ]);
          }
        }
        entity.properties["items"] = {
          type: Excel.CellValueType.array,
          elements: item_array,
        };
      }
      if (props.ship_type_id) {
        const shipType = await getCachedTypeEntity(props.ship_type_id);
        if (shipType != null) {
          entity.properties["ship_type"] = await shipType.toJson();
          //Skipping the usual deletion so it's easier to add the ship hull to cost estimations.
          //delete entity.properties["ship_type_id"];
        }
      }
      if (props.description) {
        entity.properties["description"] = {
          type: Excel.CellValueType.string,
          basicValue: props.description,
        };
      } else {
        entity.properties["description"] = {
          type: Excel.CellValueType.string,
          basicValue: "",
        };
      }

      entity.properties["name"] = {
        type: Excel.CellValueType.string,
        basicValue: props.name ? props.name : "Unknown Fitting",
      };
    }
    // Layouts
    entity.layouts = {
      card: {
        title: { property: "name" },
      },
    };

    return entity;
  }
}
